import { render, staticRenderFns } from "./AccountPerson.vue?vue&type=template&id=1ca2358c&scoped=true"
import script from "./AccountPerson.vue?vue&type=script&lang=js"
export * from "./AccountPerson.vue?vue&type=script&lang=js"
import style0 from "./AccountPerson.vue?vue&type=style&index=0&id=1ca2358c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca2358c",
  null
  
)

export default component.exports